import './vendor/ticket-template-utils.js';
import './vendor/quotation-utils.js';
import './vendor/template-transfer-utils.js';
import { COMPANY, COMPANY_NAME } from './config.js';
import { readJson } from './storage.js';
export function templateTools(kind) { return kind === 'cotizacion' ? globalThis.VendeyCotizaciones : globalThis.VendeyPlantillaTicket; }
export function templateKey(kind) { return (kind === 'cotizacion' ? 'vendeyPlantillaCotizacionV1' : 'vendeyPlantillaTicketV1') + ':' + COMPANY; }
export function loadTemplate(kind) {
  const tools = templateTools(kind); const scoped = readJson(templateKey(kind), null);
  if (scoped) return tools.normalizarPlantilla(scoped);
  const legacy = readJson(kind === 'cotizacion' ? tools.STORAGE_TEMPLATE_KEY : tools.STORAGE_KEY, null);
  if (legacy) return tools.normalizarPlantilla(legacy);
  const simple = readJson('vendeySvelteTemplate:' + COMPANY, null);
  return tools.normalizarPlantilla(kind === 'cotizacion' ? { empresa: COMPANY_NAME } : simple ? { anchoPapelMm: simple.width, textoEncabezado: simple.title, mensajePie: simple.footer } : {});
}
export function saveTemplate(kind, value) { const normalized = templateTools(kind).normalizarPlantilla(value); localStorage.setItem(templateKey(kind), JSON.stringify(normalized)); return normalized; }
export function importTemplate(kind, text) {
  let value = JSON.parse(text);
  if (kind === 'ticket-venta' && typeof value.title === 'string' && typeof value.footer === 'string') value = { anchoPapelMm: value.width, textoEncabezado: value.title, mensajePie: value.footer };
  return globalThis.VendeyTemplateTransfer.extraer(value, kind, templateTools(kind).normalizarPlantilla);
}
export function serializeTemplate(kind, value) { return globalThis.VendeyTemplateTransfer.serializar(kind, templateTools(kind).normalizarPlantilla(value)); }
